import { render, staticRenderFns } from "./AdminPermission.vue?vue&type=template&id=237e6b4a&scoped=true&"
import script from "./AdminPermission.vue?vue&type=script&lang=js&"
export * from "./AdminPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e6b4a",
  null
  
)

export default component.exports